module.exports = __webpack_public_path__ + "static/img/fhbg.7be8ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/fhbg.png
// module id = GHwl
// module chunks = 1